import React from "react";

import { trackAmplitudeEvent } from "../../amplitude";
import Icon from "../Icon";

// "Hola {{mundo}}." -> ["Hola ", <strong>mundo</strong>, "."]
const renderClozeText = (text) => (text || "").split(/\{\{(.+?)\}\}/).map((part, i) => (
  i % 2 === 1 ? <strong key={i}>{part}</strong> : <React.Fragment key={i}>{part}</React.Fragment>
));

// End of the logged-out round on a CEFR landing page (/learn/spanish/b1), in place
// of the usual round results. The answers are already held server side and get
// saved to the account on sign up, which is the promise this makes.
export default class LandingSignUp extends React.Component {
  componentDidMount() {
    trackAmplitudeEvent("web_app_cefr_landing_round_completed", this.eventProperties());
  }

  eventProperties() {
    const { amplitudeRoundProperties, numCorrect, numSentences } = this.props;
    return Object.assign({}, amplitudeRoundProperties, { num_correct: numCorrect, num_sentences: numSentences });
  }

  trackSignUpClick(method) {
    trackAmplitudeEvent("web_app_cefr_landing_sign_up_clicked", Object.assign(this.eventProperties(), { method }));
  }

  // OmniAuth only starts from a POST with the CSRF token.
  renderProviderButton({ icon, label, method, url }) {
    const csrfToken = document.querySelector("meta[name=\"csrf-token\"]");

    return (
      <form action={url} method="post" onSubmit={() => this.trackSignUpClick(method)}>
        <input name="authenticity_token" type="hidden" value={csrfToken ? csrfToken.getAttribute("content") : ""} />
        <button className="btn btn-lg btn-default btn-block" type="submit">
          <i aria-hidden="true" className={`fa fa-${icon}`} /> {label}
        </button>
      </form>
    );
  }

  renderSentences() {
    const { missedIds, sentences } = this.props;

    return (
      <ul className="cefr-landing-sentences list-unstyled">
        {sentences.map((sentence) => {
          const missed = missedIds.has(sentence.id);
          return (
            <li key={sentence.id}>
              <span className={missed ? "text-danger" : "text-success"}><Icon name={missed ? "remove" : "ok"} /></span>
              <div>
                <div className="cefr-landing-sentence-text">{renderClozeText(sentence.text)}</div>
                <div className="cefr-landing-sentence-translation">{sentence.translation}</div>
              </div>
            </li>
          );
        })}
      </ul>
    );
  }

  render() {
    const { landing, numCorrect, numSentences } = this.props;
    const numRemaining = Math.max(landing.numCollectionSentences - numSentences, 0);
    const { appleSignUpUrl, googleSignUpUrl } = landing;

    return (
      <div className="cefr-landing-sign-up">
        <h2 className="joystix text-center">{numCorrect} / {numSentences}</h2>
        <p className="lead text-center">
          {numCorrect === numSentences ? "A perfect round!" : "Round complete!"}
          {" "}Save it and keep going - {numRemaining.toLocaleString()} more sentences in {landing.collectionName}.
        </p>

        <div className="cefr-landing-sign-up-box">
          {googleSignUpUrl && this.renderProviderButton({ icon: "google", label: "Continue with Google", method: "google", url: googleSignUpUrl })}
          {appleSignUpUrl && this.renderProviderButton({ icon: "apple", label: "Continue with Apple", method: "apple", url: appleSignUpUrl })}
          <a className="btn btn-lg btn-success btn-block joystix" href={landing.signUpUrl} onClick={() => this.trackSignUpClick("email")}>
            Sign up with email <Icon name="chevron-right" />
          </a>
          <p className="text-center cefr-landing-sign-in">
            Already have an account? <a href={landing.signInUrl}>Log in</a>
          </p>
        </div>

        <h3 className="cefr-landing-sentences-title">This round</h3>
        {this.renderSentences()}
      </div>
    );
  }
}
